import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e554da1"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "module-title"
}, "方案优势", -1));
const _hoisted_2 = {
  class: "simulationTastBox"
};
const _hoisted_3 = {
  class: "sloganBox"
};
const _hoisted_4 = {
  class: "content-box"
};
const _hoisted_5 = {
  class: "imgBox code1"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "丰富的协议支持", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "覆盖近百种主流网络协议，支持创建自定义协议模型", -1));
const _hoisted_8 = {
  class: "sloganBox"
};
const _hoisted_9 = {
  class: "content-box"
};
const _hoisted_10 = {
  class: "imgBox code2"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "全自动安全检测", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "测试用例自动生成，测试策略自动优化，检出漏洞自动验证", -1));
const _hoisted_13 = {
  class: "sloganBox"
};
const _hoisted_14 = {
  class: "content-box"
};
const _hoisted_15 = {
  class: "imgBox code3"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "未知问题，提前防御", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "海量变异测试用例，支持检测已知漏洞，善于发现未知漏洞", -1));
const _hoisted_18 = {
  class: "sloganBox"
};
const _hoisted_19 = {
  class: "content-box"
};
const _hoisted_20 = {
  class: "imgBox code4"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "丰富的检测报告", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提供准确报告，包含故障分类、修复建议、漏洞详情等关键信息", -1));
const _hoisted_23 = {
  class: "sloganBox"
};
const _hoisted_24 = {
  class: "content-box"
};
const _hoisted_25 = {
  class: "imgBox code5"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "消除检测误报噪音", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "模拟程序真实运行环境，确保所有检出缺陷可复现、0误报", -1));
const _hoisted_28 = {
  class: "sloganBox"
};
const _hoisted_29 = {
  class: "content-box"
};
const _hoisted_30 = {
  class: "imgBox code6"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "无侵入", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "采用黑盒检测方式，不侵入系统或工程代码，发现深层漏洞", -1));
const _hoisted_33 = {
  class: "bannar-box"
};
const _hoisted_34 = {
  class: "sloganBox"
};
const _hoisted_35 = {
  class: "content-box"
};
const _hoisted_36 = {
  class: "imgBox code1"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "丰富的协议支持", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "覆盖近百种主流网络协议，支持创建自定义协议模型", -1));
const _hoisted_39 = {
  class: "sloganBox"
};
const _hoisted_40 = {
  class: "content-box"
};
const _hoisted_41 = {
  class: "imgBox code2"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "全自动安全检测", -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "测试用例自动生成，测试策略自动优化，检出漏洞自动验证", -1));
const _hoisted_44 = {
  class: "sloganBox"
};
const _hoisted_45 = {
  class: "content-box"
};
const _hoisted_46 = {
  class: "imgBox code3"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "未知问题，提前防御", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "海量变异测试用例，支持检测已知漏洞，善于发现未知漏洞", -1));
const _hoisted_49 = {
  class: "sloganBox"
};
const _hoisted_50 = {
  class: "content-box"
};
const _hoisted_51 = {
  class: "imgBox code4"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "丰富的检测报告", -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提供准确报告，包含故障分类、修复建议、漏洞详情等关键信息", -1));
const _hoisted_54 = {
  class: "sloganBox"
};
const _hoisted_55 = {
  class: "content-box"
};
const _hoisted_56 = {
  class: "imgBox code5"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "消除检测误报噪音", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "模拟程序真实运行环境，确保所有检出缺陷可复现、0误报", -1));
const _hoisted_59 = {
  class: "sloganBox"
};
const _hoisted_60 = {
  class: "content-box"
};
const _hoisted_61 = {
  class: "imgBox code6"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slogan"
}, "无侵入", -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "采用黑盒检测方式，不侵入系统或工程代码，发现深层漏洞", -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pagination-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'module-box active' : 'module-box')
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_6, _hoisted_7])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_11, _hoisted_12])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_16, _hoisted_17])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_withDirectives(_createElementVNode("div", _hoisted_20, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_21, _hoisted_22])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_withDirectives(_createElementVNode("div", _hoisted_25, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_26, _hoisted_27])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_31, _hoisted_32])])]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_swiper, {
    modules: _ctx.modules,
    "auto-height": true,
    "space-between": 16,
    "slides-perView": 'auto',
    "centered-slides": true,
    pagination: _ctx.pagination,
    autoplay: _ctx.autoplay,
    onSwiper: _ctx.onSwiper,
    onSlideChange: _ctx.onSlideChange
  }, {
    default: _withCtx(() => [_createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_withDirectives(_createElementVNode("div", _hoisted_36, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_37, _hoisted_38])])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_withDirectives(_createElementVNode("div", _hoisted_41, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_42, _hoisted_43])])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_withDirectives(_createElementVNode("div", _hoisted_46, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_47, _hoisted_48])])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_withDirectives(_createElementVNode("div", _hoisted_51, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_52, _hoisted_53])])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_withDirectives(_createElementVNode("div", _hoisted_56, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_57, _hoisted_58])])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_withDirectives(_createElementVNode("div", _hoisted_61, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/base-img.png'), "background-image"]]), _hoisted_62, _hoisted_63])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modules", "pagination", "autoplay", "onSwiper", "onSlideChange"]), _hoisted_64])], 2);
}